// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
import Rails from "@rails/ujs";
import '../stylesheets/application.scss'
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import '@fortawesome/fontawesome-free/js/all'
import '../stylesheets/application.scss'
import "controllers"
import * as Sentry from "@sentry/browser";

try {
    Rails.start();
} catch ( error ) {
    console.warn(`Rails UJSの初期化でエラーが発生しました: ${error.message}`)
}

Turbolinks.start()
ActiveStorage.start()

// reCAPTCHA v3のプレースホルダー要素をTurbolinksキャッシュ前にクリアする
// これにより「reCAPTCHA placeholder element must be empty」エラーを防止する
document.addEventListener('turbolinks:before-cache', function() {
    var recaptchaElements = document.querySelectorAll('.grecaptcha-badge');
    recaptchaElements.forEach(function(el) { el.remove(); });
    var recaptchaScripts = document.querySelectorAll('script[src*="recaptcha"]');
    recaptchaScripts.forEach(function(el) { el.remove(); });
    if (window.grecaptcha) {
        delete window.grecaptcha;
    }
});
Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    // 患者の IP アドレス等を Sentry に送らない（YAS-72）
    sendDefaultPii: false,

    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.
    release: "ohdr",
    integrations: [
        Sentry.browserTracingIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

});